/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import React from "react";
interface Props {
  time?: number;
}
interface State {
  hasError: boolean;
  error?: Error;
}
export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.log(error);
    // 更新 state 以至於下一個 render 會顯示 fallback UI
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
    // 你也可以把錯誤記錄到一個錯誤回報系統服務
    // logErrorToMyService(error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      // 你可以 render 任何客製化的 fallback UI
      return (
        <>
          <h5>系统发生错误.</h5>
          <ul>
            {this.state.error?.stack.split(" at ").map((v, i) => (
              <li key={i}>{v}</li>
            ))}
          </ul>
        </>
      );
    }
    return <>{this.props.children}</>;
  }
}
